import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './ArticleAuthor.module.scss'

export const ArticleAuthor = ({ name, className }) => {
  const classes = classnames(
    styles.articleAuthor,
    { [`${className}`]: className },
  )

  return (
    <address rel="author" className={classes}>
      - {name}
    </address>
  )
}

ArticleAuthor.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
}
